export function formatListOperationOutput(modelName: string, data: any): any[] {
  return data?.[modelName] || [];
}

export function formatTotalOperationOutput(modelName: string, data: any): number {
  return data?.[`${modelName}_aggregate`]?.aggregate?.count || 0;
}
